@let corporateDesign = corporateDesignService.corporateDesign();
@let texts = textStore.texts();
@let fontColor =
  corporateDesignService.isDarkModeActive()
    ? corporateDesign.colorAdmixtures.dark_text_high
    : '';
@if (corporateDesign) {
  <aw-section
    testIdAffix="deleteAccount"
    [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_01">
    <aw-section-header>
      <aw-section-headline>
        {{
          texts
            | filterTexts
              : RelationType.deleteAccountLabel
              : EEntityType.privateArea
            | language
        }}
      </aw-section-headline>
    </aw-section-header>
    <quill-view
      [style.color]="fontColor"
      [content]="
        texts
          | filterTexts
            : RelationType.deleteAccountDescriptionLabel
            : EEntityType.privateArea
          | language
      "
      [attr.aria-label]="
        texts
          | filterTexts
            : RelationType.deleteAccountDescriptionLabel
            : EEntityType.privateArea
          | language
      "
      [attr.data-testid]="'account-deletion-description-text'"
      format="json"
      theme="snow"></quill-view>
    <aw-button
      [id]="'deleteAccountButton'"
      [type]="'button'"
      [style]="'error-alt'"
      (click)="deleteAccount()"
      [text]="
        texts
          | filterTexts
            : RelationType.deleteAccountButtonLabel
            : EEntityType.privateArea
          | language
      ">
    </aw-button>
  </aw-section>
}
